export default __webpack_public_path__ + "static/media/4.97f3f6ce.png";